import React from "react";

import { Card2 } from "@/ui2/atoms/Card";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import images from "@/utils/images";
import { Link2 } from "@/ui2/atoms/Link";
import { SUPPORT_NUMBER } from "@/constants/aptihealth";
import { ViewTitle } from "@/features/dashboard/components/ViewTitle";

import "../../styles.scss";

export function FamilyMembersWidget({ profile }) {
  const associated_wards = profile?.enriched_associated_wards ?? [];
  const associated_guardians = profile?.enriched_associated_guardians ?? [];
  const familyMembers = [...associated_wards, ...associated_guardians];

  const displayAddChild = () => {
    return associated_wards.length > 0;
  };

  const renderFamilyMembers = (familyMembers) => {
    return familyMembers.map((familyMember, i) => {
      return (
        <li
          className="tw:flex tw:justify-between tw:py-5 tw:not-first:border-t tw:not-first:border-stroke-quaternary"
          key={familyMember.id || `${familyMember.first_name}-${familyMember.last_name}-${i}`}
        >
          <div className="d-flex">
            <img alt="Icon" className="pr-4" src={images("./icons/family-member-icon.svg")} />

            <div data-private="true">
              <div className="fs-18 txt-navy tw:font-bold">
                {familyMember.first_name} {familyMember.last_name}
              </div>

              <div className="fs-16 txt-gry">{familyMember.email}</div>
            </div>
          </div>

          <div className="d-md-block d-none">
            <div className="fs-16 txt-navy tw:font-bold">For Support Contact</div>
            <div className="fs-16 txt-gry">{SUPPORT_NUMBER}</div>
          </div>
        </li>
      );
    });
  };

  return (
    <section
      className="tw:grid tw:grid-rows-[min-content_1fr] tw:gap-3"
      {...getAutomationDataAttr("patient-home-family-members-widget")}
    >
      <div className="tw:flex tw:items-baseline tw:justify-between">
        <ViewTitle as="h2" size={3}>
          Family Members
        </ViewTitle>

        {displayAddChild() && (
          <Link2
            className="tw:flex tw:items-center tw:gap-2"
            href="/app/teens-and-kids/program-details"
          >
            Add Child
          </Link2>
        )}
      </div>

      <Card2 className="tw:flex-col tw:px-5">
        <ul>{renderFamilyMembers(familyMembers)}</ul>
      </Card2>
    </section>
  );
}
